export default function PlusIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M1 13H24" stroke="currentColor" strokeWidth={props.strokeWidth || 2} strokeLinecap="round" />
			<path d="M12.5 1L12.5 24" stroke="currentColor" strokeWidth={props.strokeWidth || 2} strokeLinecap="round" />
		</svg>
	);
}
